var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgTrashIcon = function SvgTrashIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 3C14 3.07652 13.9875 3.15252 13.963 3.225L12.279 13.329C12.2011 13.7962 11.9599 14.2205 11.5984 14.5265C11.237 14.8325 10.7786 15.0003 10.305 15H5.694C5.22056 15.0001 4.76245 14.8322 4.40118 14.5262C4.0399 14.2202 3.79888 13.796 3.721 13.329L2.037 3.225C2.0125 3.15251 2.00001 3.07651 2 3C2 1.895 4.686 1 8 1C11.314 1 14 1.895 14 3ZM3.215 4.207L4.708 13.164C4.74682 13.3975 4.86721 13.6097 5.04776 13.7627C5.2283 13.9158 5.45729 13.9999 5.694 14H10.306C10.5427 13.9999 10.7717 13.9158 10.9522 13.7627C11.1328 13.6097 11.2532 13.3975 11.292 13.164L12.785 4.207C11.69 4.689 9.954 5 8 5C6.046 5 4.31 4.689 3.215 4.207Z",
    fill: "#EB5757"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTrashIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/trash-icon.20447713.svg";
export { ForwardRef as ReactComponent };